export default {
  /* disable features here */
};
